var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalMallBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M0 0h24v24H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M19 6h-2A5 5 0 0 0 7 6H5a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V8a2.006 2.006 0 0 0-2-2zm-7-3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3zm0 10a4.991 4.991 0 0 1-4.84-3.75A1 1 0 0 1 8.13 8a1.041 1.041 0 0 1 .98.8 3 3 0 0 0 5.78 0 1.041 1.041 0 0 1 .98-.8 1.006 1.006 0 0 1 .97 1.25A4.991 4.991 0 0 1 12 13z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalMallBlack24Dp);
export default __webpack_public_path__ + "static/media/local_mall_black_24dp.7a2b11b45fce1ee9b56576852a85c2dd.svg";
export { ForwardRef as ReactComponent };